import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { GET_USER_IN_2N } from 'services/2n/get-user';
import { ALL_USERS } from '../get-all-users';
import { disableUserAPI } from './api';

export function useDisableUser({ onSuccess } = {}) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();

  const { mutate, mutateAsync, isLoading, isSuccess, isError } = useMutation(
    (userId) => disableUserAPI(userId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ALL_USERS, tenantId]);
        queryClient.invalidateQueries([GET_USER_IN_2N, tenantId]);
        setTimeout(() => {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'success',
              description: 'disableUserSuccessMessage',
            },
          });
        }, 100);
        if (onSuccess) {
          onSuccess();
        }
      },
      onError: () => {
        setTimeout(() => {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'error',
              description: 'genericErrorMessage',
            },
          });
        }, 100);
      },
    },
  );

  return {
    disableUser: mutate,
    disableUserAsync: mutateAsync,
    isLoading,
    isSuccess,
    isError,
  };
}
